import { LevelAbbreviations } from "../Types";

export const FiasHouseTypes: LevelAbbreviations[] = [
    {
        long: "Не определено",
        short: "Не определено",
        fiasKey: "0",
        engName: "None",
        objectID: "1214",
    },
    {
        long: "Владение",
        short: "влд.",
        fiasKey: "1",
        engName: "Hold",
        objectID: "1201",
    },
    {
        long: "Дом",
        short: "д.",
        fiasKey: "2",
        engName: "House",
        objectID: "1202",
    },
    {
        long: "Домовладение",
        short: "двлд.",
        fiasKey: "3",
        engName: "HouseHold",
        objectID: "1208",
    },
    {
        long: "Гараж",
        short: "г-ж",
        fiasKey: "4",
        engName: "Garage",
        objectID: "1211",
    },
    {
        long: "Здание",
        short: "зд.",
        fiasKey: "5",
        engName: "Building",
        objectID: "1212",
    },
    {
        long: "Шахта",
        short: "шахта",
        fiasKey: "6",
        engName: "Mine",
        objectID: "1213",
    },
    {
        long: "Строение",
        short: "стр.",
        fiasKey: "7",
        engName: "Structure",
        objectID: "1204",
    },
    {
        long: "Сооружение",
        short: "соор.",
        fiasKey: "8",
        engName: "Construction",
        objectID: "1209",
    },
    {
        long: "Литера",
        short: "литера",
        fiasKey: "9",
        engName: "Litera",
        objectID: "1205",
    },
    {
        long: "Корпус",
        short: "к.",
        fiasKey: "10",
        engName: "Housing",
        objectID: "1203",
    },
    {
        long: "Подвал",
        short: "подв.",
        fiasKey: "11",
        engName: "Basement",
        objectID: "1215",
    },
    {
        long: "Котельная",
        short: "кот.",
        fiasKey: "12",
        engName: "BoilerRoom",
        objectID: "1216",
    },
    {
        long: "Погреб",
        short: "пб.",
        fiasKey: "13",
        engName: "Cellar",
        objectID: "1217",
    },
    {
        long: "Объект нез-го стр-ва",
        short: "ОНС",
        fiasKey: "14",
        engName: "UnfinishedConstruction",
        objectID: "1218",
    },
    {
        long: "Участок",
        short: "з/у",
        fiasKey: "15",
        objectID: "1135",
    },
];
